import { secureDelete, secureGet, securePost, securePut } from "../../Config/ApiConfig";


export const getknowledgeDatabases = async ({ page, size, search, filters, id, sort_by, sort_direction } = {}) => {
    const params = new URLSearchParams();

    if (page !== undefined) {
        params.append('page', page);
    }
    if (size !== undefined) {
        params.append('page_size', size);
    }
    if (search) {
        params.append('search_string', search);
    }
    if (sort_by) {
        params.append('sort_by', String(sort_by));
    }
    if (sort_direction) {
        params.append('sort_direction', String(sort_direction));
    }

    const filtersPayload = { ...(filters || {}) };
    if (id) {
        filtersPayload.id = id;
    }

    if (Object.keys(filtersPayload).length > 0) {
        params.append('filters', JSON.stringify(filtersPayload));
    }

    const query = params.toString();
    const { data } = await secureGet(`/knowledge-bases${query ? `?${query}` : ''}`);
    return data;
};


export const getKnowledgeDatabase = async (id) => {
    const { data } = await secureGet('/knowledge-bases/' + id);
    return data;
};


export const getEntries = async (id, page) => {
    const { data } = await secureGet('/knowledge-bases/' + id + '/entries?page=' + page);
    return data;
};

export const addKnowledgeDatabase = async ({ name, description }) => {
    const { data } = await securePost('/knowledge-bases', { name, description });
    return data;
};

export const updateKnowledgeDatabase = async ({ name, description, id }) => {
    const { data } = await securePut(`/knowledge-bases/${id}`, { id, name, description });
    return data;
};

export const createOrUpdateQAEntry = async ({ id, knowledge_base_id, question, answer, is_disabled }) => {
    const url = id ? '/knowledge-bases/qa-entries/' + id : '/knowledge-bases/' + knowledge_base_id + '/qa-entries';
    const payload = {};
    if (question !== undefined) payload.question = question;
    if (answer !== undefined) payload.answer = answer;
    if (is_disabled !== undefined) payload.is_disabled = is_disabled;
    const { data } = (id
        ? await securePut(url, payload)
        : await securePost(url, payload));
    return data;
};

export const createOrUpdateBusinessInfoEntry = async ({ id, knowledge_base_id, content, is_disabled }) => {
    const url = id ? '/knowledge-bases/info-entries/' + id : '/knowledge-bases/' + knowledge_base_id + '/info-entries';
    const payload = {};
    if (content !== undefined) payload.content = content;
    if (is_disabled !== undefined) payload.is_disabled = is_disabled;
    const { data } = (id
        ? await securePut(url, payload)
        : await securePost(url, payload));
    return data;
};

export const deleteKnowledgeBase = async (id) => {
    const url = '/knowledge-bases/' + id;
    const { data } = await secureDelete(url);
    return data;
};
export const deleteEntry = async (id) => {
    const url = '/knowledge-bases/entries/' + id;
    const { data } = await secureDelete(url);
    return data;
};

/**
 * Beautify a knowledge base entry and get suggestions/warnings.
 * Expects body to include:
 *  - entry_type: 'question_answer' | 'business_info'
 *  - question/answer (for QA) OR content (for business info)
 */
export const beautifyEntry = async (knowledge_base_id, body) => {
    const url = `/knowledge-bases/${knowledge_base_id}/beautify-entry`;
    const { data } = await securePost(url, body);
    return data;
};
